export default "__VITE_ASSET__C21Vyjq2__"